import { useState, useCallback, type ReactNode } from 'react';
import type { LogType, LogEntry } from './types';
import { LogContext } from './context';

type LogProviderProps = { children: ReactNode };

export const LogProvider = ({ children }: LogProviderProps) => {
  const [logs, setLogs] = useState<LogEntry[]>([]);

  const log = useCallback((type: LogType, message: string) => {
    setLogs((prev) => [...prev, { type, message }]);
  }, []);

  const clearLog = useCallback(() => {
    setLogs([]);
  }, []);

  return (
    <LogContext.Provider value={{ logs, log, clearLog }}>
      {children}
    </LogContext.Provider>
  );
};
